<template>
    <div>
        <AddressEdit 
        :area-list="areaList"
        :default-region="defaultRegion"
        :show-delete="isEdit"
        show-set-default
        show-search-result
        :area-columns-placeholder="['请选择', '请选择', '请选择']"
        :address-info="addressInfo"
        @save="onSave"
        @delete="onDelete"
        @change-detail="onChangeDetail"/>
    </div>
</template>
<script>
import { AddressEdit, Toast } from 'vant';
import { areaList } from '@vant/area-data';
import { createAddress, upDateAddress, deleteAddress } from '../api/index.js'
export default {
    components: { AddressEdit },
    data() {
        return {
            areaList: areaList,
            addressInfo: {},
            defaultRegion: [],
            isEdit: false
        }
    },
    activated() {
        let editObj = window.localStorage.getItem('editAddress')
        window.localStorage.setItem('editAddress', '')
        this.isEdit = editObj ? true : false
        if (editObj) {
            this.addressInfo = JSON.parse(editObj)
            console.log(this.addressInfo, areaList)
            let isget = false
            for (let item in areaList.county_list) {
                if(areaList.county_list[item] == this.addressInfo.district) {
                    this.addressInfo.areaCode = item
                    isget = true
                    break;
                }
            }
            if (!isget) {
                for (let item in areaList.city_list) {
                    if(areaList.city_list[item] == this.addressInfo.city) {
                        this.addressInfo.areaCode = item
                        isget = true
                        break;
                    }
                }
            }
            if (!isget) {
                for (let item in areaList.province_list) {
                    if(areaList.province_list[item] == this.addressInfo.province) {
                        this.addressInfo.areaCode = item
                        isget = true
                        break;
                    }
                }
            }
        } else {
            this.addressInfo = {}
        }
    },
    methods: {
        onSave(e) {
            console.log(e, 'onSave')
            let saveData = {
                name: e.name,
                phone_number: e.tel,
                province: e.province,
                city: e.city,
                district: e.county,
                address: e.addressDetail,
                default_flag: e.isDefault ? 2 : 1
            }
            if(this.isEdit) {
                saveData.id = this.addressInfo.id
                upDateAddress(saveData).then(res => {
                    if(res.message == 'success') {
                        this.$router.go(-1)
                    }
                })
            } else {
                createAddress(saveData).then(res => {
                    if(res.message == 'success') {
                        this.$EventBus.$emit('setNewAddress', {isSet: true})
                        this.$router.go(-1)
                    }
                })
            }
        },
        onDelete() {
            let addressData= {
                id: this.addressInfo.id
            }
            deleteAddress(addressData).then(res => {
                if(res.message == 'success') {
                    Toast('删除成功')
                    this.$router.go(-1)
                }
            })
        },
        onChangeDetail(e) {
            if (e) {
                this.searchResult = [
                {
                    name: '黄龙万科中心',
                    address: '杭州市西湖区',
                },
                ];
            } else {
                this.searchResult = [];
            }
        }
    }
}
</script>
<style lang="sass" scoped>

</style>

